import React from 'react';

const Package = () => {
    return (
        <div className="container bg-info">
            <div>
                <h2>OUR HOLIDAYS PACKAGE</h2>
            </div>
            <hr />
            <div>
                <h6>Our goal is to achieve the best travel deals and serve the online travel industry. Our search engine allows finding the best travel deals from many online travel suppliers, hotels, and Airlines. For Global standard maintain our organizer has taken 2 IATA (International Air Transport Association) membership. And the other hand our organizer obokashIT- Information Technology company is a member of BASIS (Bangladesh Association of Software and Information Services). We believe the Travel business is a combination of travel inventory and technology. So “OBOKASH” Online Travel Community stands for your online travel business support, where we serve more than “Airlines & Travel Agents”. Our passion is our profession!</h6>
                <button type="button" class="btn btn-warning">View All</button>
            </div>
        </div>
    );
};

export default Package;